/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { emptyValidation } from "../../../../../helpers/validation";
import { getRequest } from '../../../../../helpers/axiosClient';
import DateIcon from "../../Icons/Date";
import moment from 'moment';
import productActions from "../../../../Product/Setup/redux/actions";
import { Button, Box } from "@mui/material";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';

export const TopProductsSupply = (props) => {
    const { visible, onProductAnalysisVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [productAnalysis, setProductAnalysis] = useState('');
    const [productAnalysisValue, setProductAnalysisValue] = useState('');
    const [productAnalysisVTitle, setProductAnalysisVTitle] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [groupId, setGroupId] = useState('');
    const [endDate, setEndDate] = useState(new Date());
    const [productAnalysisValueTitle, setProductAnalysisValueTitle] = useState('');
    const [customerData, setCustomerData] = useState([]);
    const [reportOpen, setReportOpen] = useState(false);
    const dispatch = useDispatch();
    const [errorProductAnalysisValue, setErrorProductAnalysisValue] = useState(false);
    const [errorProductAnalysis, setErrorProductAnalysis] = useState(false);
    const [loading, setLoading] = useState(false);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (visible) {
            dispatch({
                type: productActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
        }
    }, [visible])

    const productAnalysisFilter = (e) => {
        e.preventDefault();
        let emptyProductAnalysis = emptyValidation('Product Analysis', productAnalysis, 'dropDown');
        let emptyProductAnalysisValue = emptyValidation('Product Analysis', productAnalysisValue, 'dropDown');

        if (emptyProductAnalysis.isValid && emptyProductAnalysisValue.isValid) {
            setLoading(true);
            try {
                let url = `?type=${productAnalysis}`;
                if (productAnalysis === 'custom') {
                    url += `&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(endDate).format("YYYY-MM-DD")}`
                }
                let response = getRequest(`${process.env.REACT_APP_API_URL}/topSupplyProducts${url}`);
                response.then(payload => {
                    // Handle the fetched data here
                    let data = payload.data;
                    if (data && Object.keys(data).length > 0) {
                        console.log(groupId);
                        if (groupId) {
                            data = data.filter(el => parseInt(el.productGroupId) === parseInt(groupId));
                        }
                        setCustomerData(data.sort((a, b) => b[productAnalysisValue] - a[productAnalysisValue]));
                    } else {
                        setCustomerData([]);
                    }
                    setReportOpen(true);
                    onProductAnalysisVisible(false);
                    setProductAnalysis('');
                    setProductAnalysisValue('');
                    setLoading(false);
                }).catch(error => {
                    // Handle any errors
                    setLoading(false);
                })
            } catch (error) {
                setLoading(false);
            }
        } else {
            if (emptyProductAnalysis.errors !== '') {
                setErrorProductAnalysis(emptyProductAnalysis.errors);
            }
            if (emptyProductAnalysisValue.errors !== '') {
                setErrorProductAnalysisValue(emptyProductAnalysisValue.errors);
            }
        }
    }

    const productAnalysisTitle = (value) => {
        switch (value) {
            case "top_saled_product_today": return 'Today';
            case "top_saled_product_15": return 'Last 15 days';
            case "top_saled_product_30": return 'Last 30 days';
            case "custom": return moment(startDate).format("DD-MM-YYYY") + ' TO ' + moment(endDate).format("DD-MM-YYYY");
            default: return 'More Than 30 Days';
        };
    }

    const productAnalysisTitleValue = (value) => {
        switch (value) {
            case "totalAmount": return ' By Value';
            default: return ' By Quantity';
        };
    }

    const handleClose = () => {
        setProductAnalysis('');
        setProductAnalysisValue('');
        onProductAnalysisVisible(false);
        onMenuTitle('');
        setErrorProductAnalysisValue(false);
        setErrorProductAnalysis(false);
        setProductAnalysisVTitle('');
        setProductAnalysisValueTitle('');
        setStartDate(new Date());
        setEndDate(new Date());
        setGroupId('');
    }

    const productAnalysisMainTitle = (title) => {
        if (groupId) {
            let group = customObject(productGroupDetails, groupId);
            if (group)
                title = title + ' - ' + group?.name;
        }
        return title;
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => productAnalysisFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={["All Products Group"]}
                                placeholder="Please Select Products Group"
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={productGroupDetails}
                                parentValue={customObject(productGroupDetails, groupId)}
                                position={"bottom"}
                                customClasses={classes.customFilterNone}
                                id={idNamingConversion('All Products Group', 'productAnalysis', 'DropDown')}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        setGroupId('')
                                    }
                                }}
                                onChange={(data) => setGroupId(data?.id)}
                            />
                            <AutoCompleteComponent
                                name={["By Quantity / Value ", <span key="By Quantity / Value" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'By Quantity / Value' }]}
                                details={[{ "id": "totalQuantity", "label": "By Quantity" }, { "id": "totalAmount", "label": "By Value" }]}
                                parentValue={customObject([{ "id": "totalQuantity", "label": "By Quantity" }, { "id": "totalAmount", "label": "By Value" }], productAnalysisValue)}
                                onChange={(data) => { setProductAnalysisValue(data.id); setProductAnalysisValueTitle(data.id) }}
                                position={'bottom'}
                                id={idNamingConversion('By Quantity / Value', 'productAnalysis', 'DropDown')}
                                parentError={errorProductAnalysisValue}
                                customClasses={classes.margin30t}
                            />
                            <AutoCompleteComponent
                                name={["Product Analysis ", <span key="Product Analysis" className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'label', 'name': 'Product Analysis' }]}
                                details={[{ "id": "top_saled_product_today", "label": "Today" }, { "id": "top_saled_product_15", "label": "Last 15 Days" }, { "id": "top_saled_product_30", "label": "Last 30 Days" }, { "id": "top_saled_product_more_30", "label": "More Than 30 Days" }, { "id": "custom", "label": "Custom" }]}
                                parentValue={customObject([{ "id": "top_saled_product_today", "label": "Today" }, { "id": "top_saled_product_15", "label": "Last 15 Days" }, { "id": "top_saled_product_30", "label": "Last 30 Days" }, { "id": "top_saled_product_more_30", "label": "More Than 30 Days" }, { "id": "custom", "label": "Custom" }], productAnalysis)}
                                onChange={(data) => { setProductAnalysis(data.id); setProductAnalysisVTitle(data.id) }}
                                position={'bottom'}
                                id={idNamingConversion('Product Analysis', 'productAnalysis', 'DropDown')}
                                parentError={errorProductAnalysis}
                                customClasses={classes.margin30t}
                            />
                            {productAnalysis === 'custom' &&
                                <>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={startDate}
                                                format='dd/MM/yyyy'
                                                label="Start Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('Start Date', 'productAnalysis', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // readOnly={true}
                                                onChange={(newValue) => {
                                                    (newValue === null || newValue === 'Invalid Date') ?
                                                        setStartDate(new Date()) :
                                                        setStartDate(newValue)
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={endDate}
                                                format='dd/MM/yyyy'
                                                label="End Date"
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        id: idNamingConversion('End Date', 'productAnalysis', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                // readOnly={true}
                                                onChange={(newValue) => {
                                                    (newValue === null || newValue === 'Invalid Date') ?
                                                        setEndDate(new Date()) :
                                                        setEndDate(newValue)
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </>
                            }
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{productAnalysisMainTitle(title)} - {productAnalysisTitleValue(productAnalysisValueTitle)}</h4>
                            <p className={classes.downloadsHeading}>{productAnalysisTitle(productAnalysisVTitle)} </p>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={12}><h6>Product Name</h6></Col>
                            <Col span={4}><h6>Unit</h6></Col>
                            <Col span={4}><h6>Quantity</h6></Col>
                            <Col span={4}><h6 className={classes.textAlignRight}>Amount</h6></Col>
                        </Row>
                        {
                            customerData?.length > 0 ? customerData.map((data, i) => (
                                <Row className={clsx(classes.bill, 'no-break')}>
                                    <Col span={12}><p style={{ paddingRight: 40 }}>{data.name}</p></Col>
                                    <Col span={4}><p>{data.unit}</p></Col>
                                    <Col span={4}><p>{data.totalQuantity}</p></Col>
                                    <Col span={4}><p className={classes.textAlignRight}>₹ {currencyFormat(data?.totalAmount || 0)}</p></Col>
                                </Row>)) : <Row className={clsx(classes.bill)}><Col span={24}>
                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</p>
                                </Col></Row>
                        }
                        <Row className={clsx(classes.bill)}>
                            <Col span={12}></Col>
                            <Col span={4}></Col>
                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }} className={classes.textAlignRight}>₹ {currencyFormat(customerData?.length > 0 ? customerData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalAmount || 0), 0) : 0)}</h6></Col>
                        </Row>
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}